import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsFidoallianceComponent } from './simple-icons-fidoalliance.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsFidoallianceComponent ],
    exports:      [ SimpleIconsFidoallianceComponent ],
    bootstrap:    []
})
export class SimpleIconsFidoallianceModule {}
